<template>
    <div id="app">
      <div v-if="defaultHeader">
        <site-header />
      </div>
      <loader v-if="showLoading"></loader>
      <div class="d-flex justify-content-start" v-if="checkAgeRestrictionRender()">
        <age-toggle></age-toggle>
      </div>
      <router-view/>
      <div v-if="defaultFooter" :class="{'hide-footer': hideFooter}" >
        <site-footer />
      </div>
<!--      <location-permission />-->
      <notifications></notifications>
    </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import loader from './components/LoaderGlobal.vue'
// import LocationPermission from './components/LocationPermission.vue'
import { mapState } from 'vuex';
import AgeToggle from "./components/AgeToggle.vue";
export default {
  components: {
    SiteHeader,
    SiteFooter,
    loader,
   // LocationPermission,
    AgeToggle
  },
  mounted () {
    this.FetchColorCodeInfo();
    this.renderFavIcon();
    this.disableGoogleTranslate();
    this.setThemeColor()
    this.platformType = window.localStorage.getItem('platformType');
    this.$store.dispatch('refreshChatbotContext');
  },
  data(){
    return{
      defaultHeader: true,
      defaultFooter: true,
      hideFooter: false,
      platformType: ''
    }
  },
  methods: {
    FetchColorCodeInfo () {
      console.log('*** FetchColorCode ***')
      // let siteDomain = window.btoa(unescape(encodeURIComponent('https://enroll.purenroll.com')))
      //
      let siteDomain = window.btoa(unescape(encodeURIComponent(process.env.VUE_APP_SITE_DOMAIN)))
      let app = this
      // let siteDomain = 'aHR0cHM6Ly9lbnJvbGwucHVyZW5yb2xsLmNvbQ=='
      let url = `${process.env.VUE_APP_API_BASE}/get-external-site-dynamic-information?site_domain=${siteDomain}`
      // passing request object
      let req = new Request(url, {
        method: 'GET',
        headers: {
          'Content-Type': process.env.VUE_APP_CONTENT_TYPE,
          'Authorization': process.env.VUE_APP_AUTHORIZATION
        },
        mode: 'cors'
      })
      // Using fetch api javascript in built library for api req
      fetch(req)
          .then(response => {
            response.json().then(data => {
              // this.getCatchColor = JSON.stringify(data.data)
              // console.log('fetch response', JSON.stringify(data.data))

              // Creating cache name fetch_color_cache
              caches.open('fetch_color_cache').then((cache) => {
                // Converting response send as promise to Json object.
                const jsonResponse = new Response(JSON.stringify(data.data));
                // Storing the response on created catch
                cache.put(req, jsonResponse);
                app.$store.dispatch("themeColorList", JSON.stringify(data.data));
                app.setThemeColor()
              }).catch((err) => {
                console.log(err);
              })

            })
          })
          .catch(error => {
            console.log(error);
          });
    },
    renderFavIcon() {
      let favicon = document.getElementById("favicon");
      favicon.href = 'goenroll-fav.ico'
      document.title = 'Patriot Medical'
    },
    disableGoogleTranslate () {
     if (process.env.VUE_APP_IS_GO_ENROLL == 'false') {
       let element = document.getElementById('google_translate_element');
       element.style.display = 'none'
     }
    },
    loadChatbotWidget () {
      if (document.getElementById('corenroll-chatbot-embed')) {
        window.CoreyWidget && window.CoreyWidget.reloadFromStorage();
        return;
      }
      const script = document.createElement('script');
      script.id = 'corenroll-chatbot-embed';
      script.src = 'https://chatbot.corenroll.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
    },
    checkAgeRestrictionRender () {
      if (this.platformType == 'rep-quote') {
        return false
      } else if (this.$store.getters.isRepAuthenticated && this.$route.name !== 'AccessPage' && this.$route.name !== 'GroupHomeOption') {
        return true
      } else {
        return false
      }
    },
    setThemeColor() {
      let app = this
      try {
        let themeColorArray = app.themeColorList
        const colorArray = JSON.parse(themeColorArray);
        const themeColors = {};
        const root = document.documentElement;
        colorArray?.forEach(item => {
          if (item?.key && item?.value !== undefined) {
            themeColors[item.key] = item.value;
          }
        });
        root.style.setProperty('--brand-color', themeColors["VUE_APP_PRIMARY"]);
        root.style.setProperty('--top-header-primary-color', themeColors["VUE_APP_TOP_HEADER_COLOR"]);
        root.style.setProperty('--top-header-font-color', themeColors["VUE_APP_TOP_HEADER_FONT_COLOR"]);
        root.style.setProperty('--nav-primary-color', themeColors["VUE_APP_NAV_PRIMARY_COLOR"]);
        root.style.setProperty('--nav-color', themeColors["VUE_APP_NAV_COLOR"]);
        root.style.setProperty('--dark-btn', themeColors["VUE_APP_DARK_BTN"]);
        root.style.setProperty('--dark-btn-color', themeColors["VUE_APP_DARK_BTN_COLOR"]);
        root.style.setProperty('--brand-btn', themeColors["VUE_APP_BRAND_BTN"]);
        root.style.setProperty('--brand-btn-color', themeColors["VUE_APP_BRAND_BTN_COLOR"]);
        root.style.setProperty('--card-bandage-color', themeColors["VUE_APP_CARD_BANDAGE_COLOR"]);
        root.style.setProperty('--error-message-color', themeColors["VUE_APP_ERROR_MESSAGE_COLOR"]);
        root.style.setProperty('--font-family', themeColors["VUE_APP_FONT_FAMILY"]);
        root.style.setProperty('--font-header', themeColors["VUE_APP_FONT_HEADER"]);
        root.style.setProperty('--background-color', themeColors["VUE_APP_BACKGROUND"]);
        root.style.setProperty('--btn', themeColors["VUE_APP_BTN"]);
        root.style.setProperty('--tableth', '#333333');
        root.style.setProperty('--footer-link', themeColors["VUE_APP_FOOTER_LINK"]);
        root.style.setProperty('--multiple-tag', themeColors["VUE_APP_MULTIPLE_TAG"]);
        root.style.setProperty('--cart-btn-background', themeColors["VUE_APP_CART_BTN_BACKGROUND"]);
        root.style.setProperty('--cart-btn-color', themeColors["VUE_APP_CART_BTN"]);
        root.style.setProperty('--order-info-card-background', themeColors["VUE_APP_ORDER_INFO_CARD"]);
        root.style.setProperty('--card-btn-delete-background', themeColors["VUE_APP_CARD_BTN_DELETE_BACKGROUND"]);
        root.style.setProperty('--card-btn-delete-color', themeColors["VUE_APP_CARD_BTN_DELETE"]);
        root.style.setProperty('--card-btn-hover', themeColors["VUE_APP_CARD_BTN_HOVER"]);
        root.style.setProperty('--access-container',  themeColors["VUE_APP_ACCESS_CONTAINER"]);
        root.style.setProperty('--access-footer',  themeColors["$VUE_APP_ACCESS_fOOTER"]);
      } catch (error) {
        console.error(error);
      }
    }
  },
  watch: {
    "$route": {
      handler(newRoute) {
        if (newRoute.name == "error" || newRoute.name == 'decline-reminder-email' || newRoute.name == "landing-config-error") {
          this.defaultHeader = false;
          this.defaultFooter = false;
        } else if (newRoute.name == 'GroupHomeOption') {
          this.defaultHeader = false;
          this.hideFooter = true;
        } else if (newRoute.name === 'AccessPage') {
          this.defaultHeader = false;
          this.defaultFooter = false;
        } else {
          this.defaultHeader = true;
          this.defaultFooter = true;
          this.hideFooter = false;
        }

        if (newRoute.name === 'main' && !newRoute.params.landingurl && this.getLandingUrl) {
          this.$router.push(`/${this.getLandingUrl}`);
        }
      },
      immediate: true,
      deep: true
    },
    isChatbotReady: {
      handler(ready) {
        if (ready) {
          this.loadChatbotWidget();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      showLoading: state => state.showLoading
    }),
    isRepAuthenticated () {
      return this.$store?.getters?.isRepAuthenticated
    },
    getLandingUrl () {
      return this.$store?.getters?.getLandingUrl
    },
    themeColorList () {
      return this.$store.getters.themeColorList
    },
    isChatbotReady () {
      return this.$store.getters.isChatbotReady
    }
  }
}
</script>

<style>
@import url('assets/fonts/stylesheet.css');
@import url('assets/css/common.css');
#app {
  font-family: 'Raleway' !important;
}
body{
  background-color: #f3f8fa !important;
  position: relative;
}
body::before{
  content: '';
  position: absolute;
  background: url(./assets/body-bg.png) no-repeat;
  width: 100%;
  height: 100%;
  background-size: inherit;
  min-height: 100vh;
  background-position: right top;
  z-index: -1;
  background-attachment: fixed;
}
a, a:hover{
  color: inherit;
  text-decoration: none !important;
}

.hide-footer {
  display: none;
}
</style>

<style lang="scss" >
    //#app {
    //    font-family: Avenir, Helvetica, Arial, sans-serif;
    //    -webkit-font-smoothing: antialiased;
    //    -moz-osx-font-smoothing: grayscale;
    //    text-align: center;
    //    color: #2c3e50;
    //}
    // @import "css/common.css";
    // @import "css/index.css";
    /*@import "css/main.css";*/
    //@import "css/plan_desc.css";
    //@import "scss/main";

    // @import "assets/scss/main.scss";
    .vue-notifyjs {
      .alert {
        z-index: 1080 !important;
        &.alert-with-icon {
          padding-left: 25px !important;
        }
        .alert-icon {
          margin-right: 15px !important;
        }
        .close ~ span {
          display: inline-block !important;
        }
      }
    }

</style>
